import { ISidebarStateRepository } from "@/core/repositories/sidebarState";

export class ResetSidebarStateUseCase {
  constructor(private readonly sidebarStateRepository: ISidebarStateRepository) {}

  async execute(): Promise<void> {
    await this.sidebarStateRepository.resetSidebarState();
  }
}
